import React, { useEffect } from 'react';

import { LinearProgress } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

import useConfig from 'UI/customHooks/useConfig';
import { clientLogger } from 'UI/lib';
import { getFullCdnUrl } from 'UI/lib/getUrlType';

import styles from './styles';

const SplashScreen = ({ classes, error }) => {
  const { headerLogoUrl, loaderImage, isConfigLoading, splashLogoStyle } = PALYX_WHITE_LABEL;

  const hasLogoUrl = !isConfigLoading && (headerLogoUrl || loaderImage);
  const { rootWidth, progressBarMarginTop } = splashLogoStyle ?? {};
  const { cdnUrl } = useConfig();

  useEffect(() => {
    if (error) {
      clientLogger.error(error);
    }
  }, [error]);

  return (
    <div key="splash-screen">
      <div className={classes.root} style={{ width: rootWidth }}>
        {hasLogoUrl && (
          <img src={getFullCdnUrl(loaderImage || headerLogoUrl, cdnUrl)} alt="logo" width="100%" />
        )}
        <div className={classes.progressWrapper} style={{ marginTop: progressBarMarginTop }}>
          <LinearProgress classes={{ root: classes.progress }} />
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(SplashScreen);
